import { ExternalUserEQueriesColumns } from '../../../e-queries/e-queries-columns/external-user-e-queries-columns';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { ExternalUserEQuery } from '../../../e-queries/models/external-user-e-query';
import { Observable } from 'rxjs';
import { CovanceGridColumn } from '../../../covance-ag-grid';
import { Site } from '../../../sites';
import { GridColumns } from '../../../shared/grid-columns';
import { EQueriesColumns } from '../../../e-queries/e-queries-columns';
import { UrlBuilder } from '../../../core';
import { Injectable } from '@angular/core';
import { SubjectTitleRenderer } from '../../../renderer/subject-title-renderer';

@Injectable()
export class InvestigatorEQueriesColumns {
    constructor(
        private readonly gridColumns: GridColumns,
        private readonly eQueriesColumns: EQueriesColumns,
        private readonly urlBuilder: UrlBuilder,
        private readonly externalUserEQueriesColumns: ExternalUserEQueriesColumns
    ) {
    }

    public getAwaitingColumns(site$: Observable<Site>): Observable<CovanceGridColumn[]> {
        return site$.pipe(
            map(site => [
                this.externalUserEQueriesColumns.viewHistory,
                this.eQueriesColumns.eQueryIdColumn<ExternalUserEQuery>(
                    params =>
                        this.urlBuilder
                            .esa()
                            .globalPopup()
                            .investigatorEQueryDetails(params.data.eQueryId)
                            .url()),
                this.externalUserEQueriesColumns.status,
                this.eQueriesColumns.ageColumn(),
                this.gridColumns.subjectColumn<ExternalUserEQuery>(
                    params =>
                        this.urlBuilder
                            .esa()
                            .site(site)
                            .subject({zcSubjectId: params.data.zcSubjectId})
                            .url(),
                    data => SubjectTitleRenderer.renderSubjectNumberOrScreening(data)),
                this.gridColumns.accessionNumberColumn<ExternalUserEQuery>(
                    params =>
                        this.urlBuilder
                            .esa()
                            .site(site)
                            .onScreenResults()
                            .standardTestResults()
                            .testResults()
                            .url(),
                    data => [data.accessionNumber],
                ),
                this.externalUserEQueriesColumns.visitCollectionDate,
                this.externalUserEQueriesColumns.visitName,
                this.externalUserEQueriesColumns.protocolVisitCode,
            ]),
            publishReplay(1),
            refCount(),
        );
    }

    public getSubmittedColumns(site$: Observable<Site>): Observable<CovanceGridColumn[]> {
        return site$.pipe(
            map(site => [
                this.eQueriesColumns.eQueryIdColumn<ExternalUserEQuery>(
                    params =>
                        this.urlBuilder
                            .esa()
                            .globalPopup()
                            .investigatorEQueryDetails(params.data.eQueryId)
                            .url()),
                this.externalUserEQueriesColumns.status,
                this.gridColumns.subjectColumn<ExternalUserEQuery>(
                    params =>
                        this.urlBuilder
                            .esa()
                            .site(site)
                            .subject({zcSubjectId: params.data.zcSubjectId})
                            .url(),
                    data => SubjectTitleRenderer.renderSubjectNumberOrScreening(data)),
                this.gridColumns.accessionNumberColumn<ExternalUserEQuery>(
                    params =>
                        this.urlBuilder
                            .esa()
                            .site(site)
                            .onScreenResults()
                            .standardTestResults()
                            .testResults()
                            .url(),
                    data => [data.accessionNumber],
                ),
                this.externalUserEQueriesColumns.visitCollectionDate,
                this.externalUserEQueriesColumns.visitName,
                this.externalUserEQueriesColumns.protocolVisitCode,
                this.eQueriesColumns.responders(),
                this.externalUserEQueriesColumns.responseTime
            ]),
            publishReplay(1),
            refCount(),
        );
    }
}
